'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _usageData = require('./usage-data.html');

var _usageData2 = _interopRequireDefault(_usageData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _usageData2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    dialogTitle: '@',
    locked: '<',
    showGuidance: '<',
    usages: '<',
    showHeader: '<',
    showActionButtons: '<',
    usageDataChanged: '&',
    missingMessage: '@'
  },
  controller: function () {
    function UsageDataFormComponent(EventEmitter, UsageDataService) {
      'ngInject';

      _classCallCheck(this, UsageDataFormComponent);

      Object.assign(this, {
        EventEmitter: EventEmitter,
        UsageDataService: UsageDataService
      });
    }

    _createClass(UsageDataFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.Q4Value = 0;
        this.getQ4Value();
        this.query = (0, _query.getQuery)();
        this.limitOptions = [5, 10, 25, 50];

        if (!(this.dialogTitle && this.dialogTitle.length)) {
          this.dialogTitle = 'Number of Units Shipped (Shipping Data)';
        }
      }
    }, {
      key: 'getQ4Value',
      value: function getQ4Value() {
        var _this = this;

        var promise = this.UsageDataService.getQ4Value(this.usages[0].ProductId, this.usages[0].UsageYear - 1);

        return promise.then(function (result) {
          _this.Q4Value = result.data;
        });
      }
    }, {
      key: 'showWarning',
      value: function showWarning(value1, value2) {
        if ((value1 - value2) / value2 > 1) {
          return true;
        } else if ((value2 - value1) / value1 > 1) {
          return true;
        }
        return false;
      }
    }, {
      key: 'showWarningMessage',
      value: function showWarningMessage() {
        var errors = document.getElementsByClassName('error-icon');
        if (errors.length > 0) {
          if (errors.length === 1 && errors[0].classList[1] === 'warning-message') {
            return false;
          }
          return true;
        }
        return false;
      }
    }, {
      key: 'calculateUsageTotal',
      value: function calculateUsageTotal(usage) {
        return +usage.Q1 + +usage.Q2 + +usage.Q3 + +usage.Q4;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.usageDataChanged(this.EventEmitter({
          usages: this.usages
        }));
      }
    }]);

    return UsageDataFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/usage-data/usage-data.component.js